module.exports = __webpack_public_path__ + "media/price_bot/closeGrey-70658cc4.svg";